import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Alert, Button, Link, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SubscriptionTierBadge, UpgradeNow } from 'src/components/SubscriptionTier';
import { useStore } from 'src/stores';
import { SUBSCRIPTION_FORM_URL } from 'src/constants/billAutomation';
import { requestBillAutomationUpgrade } from './requestBillAutomationUpgrade';
const NEEDS_LINE = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '4px'
};

/**
 * With billing options on, a portal login is Autopilot's (PRD V3, FR-5): the plan lock every setup shows, with Upgrade
 * now (LB-6187), which staff see without the button.
 */
const AutopilotLock = _ref => {
  let isLivableStaff = _ref.isLivableStaff;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "8px",
    sx: {
      marginY: '8px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, isLivableStaff ? "This company's plan doesn't include Autopilot, so portal logins can't be stored for it." : 'Portal logins need Autopilot: Livable fetches bills from utility portals on Autopilot.'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "div",
    sx: NEEDS_LINE
  }, "Needs ", /*#__PURE__*/React.createElement(SubscriptionTierBadge, {
    tier: "Autopilot"
  }), /*#__PURE__*/React.createElement(UpgradeNow, {
    tier: "Autopilot",
    where: "portal login"
  })));
};

/** Shown in place of the credential form when the company has no Bill Automation. Staff cannot buy for a customer. */
export const UpgradeNotice = observer(_ref2 => {
  var _store$account;
  let isLivableStaff = _ref2.isLivableStaff;
  const store = useStore();
  const _useState = useState('idle'),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1]; // idle | sending | sent | failed

  if (store !== null && store !== void 0 && (_store$account = store.account) !== null && _store$account !== void 0 && (_store$account = _store$account.featureFlagsStore) !== null && _store$account !== void 0 && _store$account.getIsBillingOptionsEnabled) {
    return /*#__PURE__*/React.createElement(AutopilotLock, {
      isLivableStaff: isLivableStaff
    });
  }
  if (isLivableStaff) {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      sx: {
        marginY: '8px'
      }
    }, "This company is not subscribed to Bill Automation, so portal logins cannot be stored for it.");
  }
  const handleUpgradeClick = async () => {
    setState('sending');
    setState((await requestBillAutomationUpgrade(store.account.userProfile)) ? 'sent' : 'failed');
  };
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "8px",
    sx: {
      marginY: '8px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Bill Automation collects this utility's bills with your portal login, so nobody has to download and upload them. It is not on your plan yet."), state === 'sent' ? /*#__PURE__*/React.createElement(Alert, {
    severity: "success"
  }, "We've forwarded your request. You haven't been upgraded yet; someone from our support team will follow up with you to discuss.") : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    disabled: state === 'sending',
    onClick: handleUpgradeClick,
    sx: {
      alignSelf: 'flex-start'
    }
  }, "Upgrade to Bill Automation"), state === 'failed' ? /*#__PURE__*/React.createElement(Alert, {
    severity: "warning"
  }, "We couldn't send your request.", ' ', /*#__PURE__*/React.createElement(Link, {
    href: SUBSCRIPTION_FORM_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Open the request form"), ' ', "instead.") : null);
});